export default __webpack_public_path__ + "static/BannerDraftJsMarkupFieldAndTitle-d148dc8e2ed76a8e8ccd69462b5a82d3.jpg";